import styles from "@/styles/supplier.module.scss"
import Head from "next/head"
import { useState, useEffect, useRef } from "react"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import { Button, Form, Input, message } from 'antd'
import systemApi from '@/service/modules/systemApi'
import supplierApi from '@/service/modules/supplierApi'
// @ts-ignore
import ReCAPTCHA from 'react-google-recaptcha';

export default function Supplier() {
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const [form] = Form.useForm()
  const { TextArea } = Input;

  const [siteKey, setSiteKey] = useState('')
  const [recaptchaToken, setRecaptchaToken] = useState('');

  // 获取Recaptcha token
  const handleRecaptchaChange = (value: string | null) => {
    setRecaptchaToken(value || '')
  };
  const getRecaptchaSiteKey = async () => {
    try {
      let res = await systemApi.getRecaptchaSiteKey()
      if (res.data && res.data.siteKey) {
        setSiteKey(res.data.siteKey)
      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getRecaptchaSiteKey()
  }, [])

  // 校验成功，发起提交请求
  const onFinish = async(values: any) => {
    try {
      const recaptcha = recaptchaRef.current?.getValue();
      if (!siteKey || !recaptcha) {
        message.error('Please verify you are not a robot')
        return
      }

      let dataObj = {
        company_name: values.companyName,
        trading_name: values.tradingName,
        abn: values.abn,
        address: values.address,
        company_website: values.companyWebsite,
        optional1: values.warehouseCountry,
        optional2: values.companyDescription,
    
        optional3: values.salesLink,
        optional4: values.brandNames,
        optional5: values.category,
        optional6: values.warrantyTerms,
        drop_ship_available: values.dropshipAvaliable,
        datafeed_available: values.dataFeedAvaliable,
        optional7: values.australianSafetyStandardCertification,
        optional8: values.claimsProcedure,
    
        contact_person: values.contactPerson,
        contact_mobile: values.contactMobile,
        contact_email: values.contactEmail,

        recaptcha
      }

      let res = await supplierApi.submitSupplier(dataObj)
      if (res.data) {
        message.success('Submit Success')
        window.location.reload()
      }
    } catch (error: any) {
      message.error(error.message)
    }
  }

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['page-supplier']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content']}>
            <div className={`${styles['ask-title']}`} style={{ fontSize: '26px' }}>Supplier</div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Welcome to CrazySales.com.au, We are one of the biggest online department stores in Australia and are 100% Australian owned and operated. We pride ourselves in offering you a vast range of products ranging from household goods to electricals to pet supplies and sporting goods - just about anything you can think of! An internet leader in providing customers with high quality and brand name products at unbeatable prices. Top brands, Real savings!            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Currently our website offers more than 10,000 products in comprehensive categories. There are over 600,000 registered customers, more than 25,000 website visits daily with more than 2000 products being sent to customers&apos; everyday. Due to this high growth and fast expansion, we seek to diversify our categories to meet customer needs. As we are an online business, you can shop on our site for bargains all year round - 24 hours a day, 7 days a week!
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Thanks for showing your interest with us. If you would like to become a supplier, please spend some time to fill out the information below and our team will allocate the appropriate person to follow up with you.
            </div>

            <div className={`${styles['content-title']} padding-top-30`}>
              Supplier Registration
            </div>


            <Form
              name="basic"
              layout="vertical"
              size={'large'}
              style={{ width: '100%' }}
              form={form}
              onFinish={onFinish}
              autoComplete="off"
              scrollToFirstError
            >

              <div className={styles['form-box']}>
                <div className={`${styles['ask-title']}`}>Company Details</div>
                <div className={styles['box-item']}>
                  <Form.Item
                    label="Company’s Name"
                    name="companyName"
                    style={{width: '100%', marginRight: '16px'}}
                    rules={[
                      { required: true, message: `Company’s Name is required`}
                    ]}
                  >
                    <Input placeholder="Company’s Name" />
                  </Form.Item>

                  <Form.Item
                    label="Trading Name"
                    name="tradingName"
                    style={{width: '100%'}}
                    rules={[{ required: true, message: `Trading Name is required`},]}
                  >
                    <Input placeholder="Trading Name" />
                  </Form.Item>
                </div>

                <div className={styles['box-item']}>
                  <Form.Item
                    label="ABN"
                    name="abn"
                    style={{width: '100%', marginRight: '16px'}}
                    rules={[
                      { required: true, message: `ABN is required`}
                    ]}
                  >
                    <Input placeholder="ABN" />
                  </Form.Item>

                  <Form.Item
                    label="Address"
                    name="address"
                    style={{width: '100%'}}
                    rules={[{ required: true, message: `Address is required`},]}
                  >
                    <Input placeholder="Address" />
                  </Form.Item>
                </div>

                <div className={styles['box-item']}>
                  <Form.Item
                    label="Company’s Website"
                    name="companyWebsite"
                    style={{width: '100%', marginRight: '16px'}}
                    rules={[
                      { required: true, message: `Company’s Website is required`}
                    ]}
                  >
                    <Input placeholder="Company’s Website" />
                  </Form.Item>

                  <Form.Item
                    label="In what country is your warehouse located"
                    name="warehouseCountry"
                    style={{width: '100%'}}
                  >
                    <Input placeholder="In what country is your warehouse located" />
                  </Form.Item>
                </div>

                <div className={styles['box-item']}>
                  <Form.Item
                    label="Brief description of your company"
                    name="companyDescription"
                    style={{width: '100%'}}
                  >
                    <TextArea rows={4} placeholder="Brief description of your company" />
                  </Form.Item>
                </div>

                <div className={`${styles['ask-title']}`}>Sales Details</div>
                <div className={styles['box-item']}>
                  <Form.Item
                    label="Sales Channel/Platform link: (Ebay / Amazon / Catch / Kogan / Other market place)"
                    name="salesLink"
                    style={{width: '100%'}}
                  >
                    <TextArea rows={4} placeholder="Sales Channel/Platform link: (Ebay / Amazon / Catch / Kogan / Other market place)" />
                  </Form.Item>
                </div>
                <div className={styles['box-item']}>
                  <Form.Item
                    label="Brand Names"
                    name="brandNames"
                    style={{width: '100%', marginRight: '16px'}}
                  >
                    <Input placeholder="Company’s Name" />
                  </Form.Item>

                  <Form.Item
                    label="Category"
                    name="category"
                    style={{width: '100%'}}
                  >
                    <Input placeholder="Category" />
                  </Form.Item>
                </div>
                <div className={styles['box-item']}>
                  <Form.Item
                    label="Warranty Terms"
                    name="warrantyTerms"
                    style={{width: '100%'}}
                  >
                    <TextArea rows={4} placeholder="Warranty Terms" />
                  </Form.Item>
                </div>
                <div className={styles['box-item']}>
                  <Form.Item
                    label="Dropship avaliable"
                    name="dropshipAvaliable"
                    style={{width: '100%', marginRight: '16px'}}
                    rules={[
                      { required: true, message: `Dropship avaliable is required`}
                    ]}
                  >
                    <Input placeholder="Dropship avaliable" />
                  </Form.Item>

                  <Form.Item
                    label="Data feed avaliable"
                    name="dataFeedAvaliable"
                    style={{width: '100%'}}
                    rules={[{ required: true, message: `Data feed avaliable is required`},]}
                  >
                    <Input placeholder="Data feed avaliable" />
                  </Form.Item>
                </div>
                <div className={styles['box-item']}>
                  <Form.Item
                    label="Australian Safety Standard Certification"
                    name="australianSafetyStandardCertification"
                    style={{width: '100%'}}
                  >
                    <TextArea rows={4} placeholder="Australian Safety Standard Certification" />
                  </Form.Item>
                </div>
                <div className={styles['box-item']}>
                  <Form.Item
                    label="Claims Procedure"
                    name="claimsProcedure"
                    style={{width: '100%'}}
                  >
                    <TextArea rows={4} placeholder="Claims Procedure" />
                  </Form.Item>
                </div>


                <div className={`${styles['ask-title']}`}>Contact Details</div>
                <div className={styles['box-item']}>
                  <Form.Item
                    label="Contact Person"
                    name="contactPerson"
                    style={{width: '100%', marginRight: '16px'}}
                    rules={[
                      { required: true, message: `Contact Person is required`}
                    ]}
                  >
                    <Input placeholder="Contact Person" />
                  </Form.Item>

                  <Form.Item
                    label="Contact(M)"
                    name="contactMobile"
                    style={{width: '100%'}}
                    rules={[
                      { required: true, message: `Contact(M) is required`},
                      {
                        validator(_, value) {
                          if (value && !value.match(/^[0][234578][0-9]{8}$/)) {
                            return Promise.reject(new Error('Invalid Contact(M)'));
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}
                  >
                    <Input placeholder="Contact(M)" />
                  </Form.Item>
                </div>
                <div className={styles['box-item']}>
                  <Form.Item
                    label="Contact(e-mail)"
                    name="contactEmail"
                    style={{width: 'calc(50% - 8px)'}}
                    rules={[
                      { required: true, message: `Contact(e-mail) is required`},
                      { type: 'email', message: `Invalid Email Address`},
                    ]}
                  >
                    <Input placeholder="Contact(e-mail)" />
                  </Form.Item>
                </div>

                {
                  !!(siteKey) &&
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={siteKey}
                    type={'audio'}
                    onChange={handleRecaptchaChange}
                  />
                }

              </div>

              {/* 提交按钮 */}
              <Form.Item style={{ marginBottom: 0 }}>
                <div className={styles['btn-box']}>
                  <Button 
                    className={styles['save-btn']} 
                    htmlType="submit"
                  >
                    Submit Form
                  </Button>

                  <Button
                    className={styles['cancel-btn']}
                    href="/"
                  >
                    Continue Shopping
                  </Button>
                </div>
              </Form.Item>
            </Form>

          </div>
        </div>
      </DefaultLayout>
    </>
  )
}